// extracted by mini-css-extract-plugin
module.exports = {"page-block-body":"PageBlockBodyContent_page-block-body__MsxgJ"};